var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.3333 9.33333v2.66667zm0 2.66667v2.6667zm0 0h2.6667zm0 0h-2.6666zm-4.4444-4.44444c0 .94299-.3746 1.84736-1.0414 2.51414-.6668.6668-1.5712 1.0414-2.51417 1.0414-.94299 0-1.84736-.3746-2.51415-1.0414-.6668-.66678-1.0414-1.57115-1.0414-2.51414 0-.943.3746-1.84737 1.0414-2.51416.66679-.6668 1.57116-1.0414 2.51415-1.0414.94297 0 1.84737.3746 2.51417 1.0414.6668.66679 1.0414 1.57116 1.0414 2.51416zm-8.8889 11.55554c0-1.4145.5619-2.771 1.5621-3.7712 1.00019-1.0002 2.35675-1.5621 3.77123-1.5621 1.41447 0 2.77107.5619 3.77127 1.5621s1.5621 2.3567 1.5621 3.7712v.8889h-10.6667z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPerson);
export default __webpack_public_path__ + "static/media/add-person.c01d8d3e51af7e3f25987b31e42df3ea.svg";
export { ForwardRef as ReactComponent };